import React from 'react'
import { NavLink } from 'react-router-dom'

import styles from './Sidebar.module.css'

const Sidebar = () => {
  return (
    <div className={styles.container}>
      <NavLink to="/admin/permissions" activeClassName={styles.selected}>
        Permissions
      </NavLink>
      <NavLink to="/admin/roles" activeClassName={styles.selected}>
        Roles
      </NavLink>
      <NavLink to="/admin/users" activeClassName={styles.selected}>
        Users
      </NavLink>
      <NavLink to="/admin/incidentTypes" activeClassName={styles.selected}>
        Incident Types
      </NavLink>
      <NavLink to="/admin/incidentCategories" activeClassName={styles.selected}>
        Incident Categories
      </NavLink>
      <NavLink to="/admin/incidentDivisions" activeClassName={styles.selected}>
        Incident Divisions
      </NavLink>
      <NavLink to="/admin/aiLayers" activeClassName={styles.selected}>
        AI Layers
      </NavLink>
      <NavLink to="/admin/overlays" activeClassName={styles.selected}>
        Overlays
      </NavLink>
      <NavLink to="/admin/buffers" activeClassName={styles.selected}>
        Default Buffers
      </NavLink>
      {/* <NavLink to="/admin/loginLogs" activeClassName={styles.selected}>
        Login Logs
      </NavLink> */}
      {/* <NavLink
        to="/admin/palmetto/incidentTypes"
        activeClassName={styles.selected}
      >
        Palmetto Incident Types
      </NavLink>
      <NavLink
        to="/admin/palmetto/sentIncidents"
        activeClassName={styles.selected}
      >
        Palmetto Sent Incidents
      </NavLink> */}
      <NavLink
        to="/admin/sigevents/incidents"
        activeClassName={styles.selected}
      >
        SigEvents Incidents
      </NavLink>
    </div>
  )
}

export default Sidebar
